// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pre-footer-cta-v2-wrapper_wrapper__6ADI7"};